import { IonicModule } from '@ionic/angular';
import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components/components.module';
import { LocationPermissionRequiredPage } from './location-permission-required';
import { SharedModule } from "../../shared/shared/shared.module";

const homeRoutes: Routes = [
  {
    path: '',
    component: LocationPermissionRequiredPage
  }
];

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    ReactiveFormsModule,
    ComponentsModule,
    RouterModule.forChild(homeRoutes),
    SharedModule
],
  declarations: [
    LocationPermissionRequiredPage
  ]
})
export class LocationPermissionRequiredPageModule {}
